import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../../selectors/auth";
import _ from "lodash";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../../../services/axiosInstance";
import Helper from "../../../../utils/Helper";
import {Container, Form, Row} from "react-bootstrap";
import * as ipoSelectors from "../../../../selectors/ipo";
import * as StorageManager from "../../../../utils/StorageManager";
import constants from "../../../../constants";
import clsx from "clsx";
import CustomConfirmationModal from "../../../../components/CustomConfirmationModal";
import * as ipoActions from "../../../../action/ipo";

function EIPOSubscribeConfirmation({ipoConfig}) {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmationModalShow, setConfirmationModalShow] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const dispatch = useDispatch();
  const numberOfShares = useSelector((state) =>
      _.get(state, ["ipo", "data", "number_of_share_applied"]),
  );
  const totalTrustAmt = useSelector((state) =>
      _.get(state, ["ipo", "ipoConfig", "metadata", "total_trust_balance"]),
  );

  const raceData = useSelector((state) =>_.get(state,['ipo','data','race'],null))
  const races = ipoSelectors.getIpoConfigRaces(ipoConfig);
  const race = _.find(races,_.matchesProperty('value',raceData))
  const { ipoID } = useParams();
  const history = useHistory();
  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }
  const { data, isLoading } = useQuery({
    queryKey: ["subscribe-ipo-confirmation", { ipoID }],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo/${ipoID}`);
      } catch (e) {
        const error = _.get(e, ["status"]);
        if (error == "404") {
          setNotFound(true);
        }
        Helper.handleHttpError(e, dispatch, history);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token) && !_.isEmpty(ipoID),
  });

  const onHandleBack = () => {
    history.goBack(null);
  }

  const onConfirm = async() => {
    setLoading(true);
    try {
        const response = await axiosInstance.post("/clientarea/ipo/subscription", {
          ipo_id: ipoID,
          number_of_share_applied: numberOfShares*lotSize,
          race: race?.value,
        });
        if (response.code === 200) {
          dispatch(ipoActions.removeIPODetail());
          dispatch(ipoActions.removeIpoConfig());
          history.push("/dashboard/e-ipo/history");
        }
    }catch (e) {}
    finally {
      setLoading(false);
    }
  }
  const ipoData = _.get(data, ["data"], null);
  const stockCode = ipoSelectors.getIPODetailStockCode(ipoData);
  const stockName = ipoSelectors.getIPODetailStockName(ipoData);
  const pricePerShare = ipoSelectors.getIPODetailPricePerShare(ipoData);
  const pricePerShareValue =
    ipoSelectors.getIPODetailPricePerShareValue(ipoData);
  const lotSize = ipoSelectors.getIPODetailLotSizeValue(ipoData)
  const issueNo = ipoSelectors.getIPODetailIssueNo(ipoData);

  return  <Container fluid>
    <div className="ipo-detail-container">
      <div>
          <div className="ipo-title">Confirmation Page</div>
          <div className="ipo-stockcode">Please make sure your information is accurate before submitting.</div>
      </div>
      <div
          className={"primary-border-table-border mt-4"}
      >
        <div
            className={clsx(
                "d-flex custom-card-label-container align-items-center justify-content-center",
            )}
        >
          <h2>Subscribe</h2>
        </div>
        <div className={clsx("custom-table-info-container padding-12px mt-3 mb-1")}>
          <div className="ipo-subscribe-container">
            <div className="ipo-subscribe-detail-container">
              <div className="ipo-subscribe-content" style={{flex: 2}}>
                <div className="ipo-subscribe-content-title"></div>
                <div className="ipo-subscribe-content-text" style={{flexDirection: "column", alignItems: 'flex-start'}}>
                  <div><b>{stockName}</b></div>
                  <div>{stockCode}</div>
                </div>
              </div>
              <div className="ipo-subscribe-content" style={{flex: 2}}>
                <div className="ipo-subscribe-content-title">Issue No</div>
                <div className="ipo-subscribe-content-text">
                  {issueNo}
                </div>
              </div>
              <div className="ipo-subscribe-content" style={{flex: 2}}>
                <div className="ipo-subscribe-content-title">Share Price</div>
                <div className="ipo-subscribe-content-text">
                  {pricePerShare}
                </div>
              </div>
              <div className="ipo-subscribe-content" style={{flex: 2}}>
                <div className="ipo-subscribe-content-title">Race</div>
                <div className="ipo-subscribe-content-text">
                  {race?.text}
                </div>
              </div>
              <div className="ipo-subscribe-content" style={{flex: 2}}>
                <div className="ipo-subscribe-content-title">Subscription Method</div>
                <div className="ipo-subscribe-content-text">
                  Trust Money
                </div>
              </div>
              <div className="ipo-subscribe-content" style={{flex: 2}}>
                <div className="ipo-subscribe-content-title">Number of Units (x{lotSize})</div>
                <div className="ipo-subscribe-content-text">
                  {numberOfShares}
                </div>
              </div>
            </div>
            <div className="ipo-subscribe-detail-container justify-content-end">
              <div className="d-flex total-price-container total-price-container-mobile">
                <div className="ipo-subscribe-total-container justify-content-end">
                  <div className="w-100">Total Trust Amount</div>
                  <div className="ipo-price-value">{Helper.formattedPrice(totalTrustAmt)}</div>
                </div>
                <div className="ipo-subscribe-total-container justify-content-end mt-2">
                  <div className="w-100">Total Subscription Amount</div>
                  <div
                      className="ipo-price-value">{Helper.formattedPrice(numberOfShares * pricePerShareValue * lotSize)}</div>
                </div>
                <div className="divider-ipo mt-2"></div>
                <div className="ipo-subscribe-total-container justify-content-end mt-2">
                  <div className="w-100">Balance Amount</div>
                  <div
                      className="ipo-price-value">{Helper.formattedPrice(totalTrustAmt + (numberOfShares * pricePerShareValue * lotSize))}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="d-flex justify-content-center py-3">
          <button
              className={clsx("btn custom-button-back")}
              //  type="submit"
              onClick={onHandleBack}
          >
            Back
          </button>
          <button
              className={clsx("btn custom-button-primary")}
              type="submit"
              //  disabled={!_.isEqual(Helper.formattedPrice(numberOfShares * pricePerShareValue * 100), Helper.formattedPrice(totalSelectedAmount))}
              style={{backgroundColor: "#9D7905"}}
              onClick={() => setConfirmationModalShow(true)}
          >
            Confirm
          </button>
        </div>

      </div>
    </div>
    <CustomConfirmationModal
      show={confirmationModalShow}
      title="Confirmation"
      desc="Are you confirm to submit it?"
    confirm={onConfirm}
      loading={loading}
      handleClose={()=>setConfirmationModalShow(false)}
    >

    </CustomConfirmationModal>
  </Container>
}

export default EIPOSubscribeConfirmation;